import React from 'react';
import c from 'classnames';

import { SearchkitWrapper } from '@uncinc/react-searchkit';
import { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';
import { SearchSettingsConfig } from '@uncinc/react-searchkit/types';

import { APP_OPTIONS, SEARCHKIT_HOST_URL } from '../../config/constants';

import './style.scss';

// Subcomponents.
import Facets from './Facets';
import Results from './Results';

interface SearchAllProjectsSubComponents {
  Facets: typeof Facets;
  Results: typeof Results;
}

export interface SearchAllProjectsProps extends Omit<SearchkitWrapperProps, 'connection' | 'searchSettings' | 'indexName'> {
  className?: string;
}

// eslint-disable-next-line max-len
const SearchAllProjects: React.FC<SearchAllProjectsProps> & SearchAllProjectsSubComponents = (props) => {
  const {
    className,
    children,
    ...restProps
  } = props;

  const classNames = c('SearchAllProjects', className);

  const searchSettings: SearchSettingsConfig = {
    search_attributes: ['title', 'body'],
    result_attributes: [
      'title',
      'body',
      'latlon',
      'project_status',
      'project_type',
      'url',
      'nid',
      'image_style_uri',
      'image_svg_url',
    ],
    facet_attributes: [
      {
        attribute: 'project_status',
        field: 'project_status',
        type: 'string',
      },
      {
        attribute: 'project_type',
        field: 'project_type',
        type: 'string',
      },
    ],
    sorting: {
      default: {
        field: 'title',
        order: 'asc',
      },
    },
  };

  return (
    <SearchkitWrapper
      {...restProps}
      className={classNames}
      connection={{
        host: SEARCHKIT_HOST_URL,
      }}
      indexName={APP_OPTIONS.parameters.searchkitIndexAllProjects}
      searchSettings={searchSettings}
    >
      {children}
    </SearchkitWrapper>
  );
};

SearchAllProjects.Facets = Facets;
SearchAllProjects.Results = Results;

export default SearchAllProjects;
